import React from 'react';

import iconTime from "../assets/images/Icon_Reloj.png";
import iconScore from "../assets/images/Icon_Star.png";
import iconLifes from "../assets/images/Icon_Life2.png";
import iconGameOver from "../assets/images/Icon_FinJuego.png";

import useScreenOrientation from './helpers/useScreenOrientation';
import isMobileDevice from './helpers/isMobileDevice';

export default function SceneUI({ isVisible, setHorizontalMovement, setVerticalMovement, userScoreUI, userTimeUI, userLifesUI, gameOver}: any) {
  
  const isLandscape = useScreenOrientation();
  const isMobile = isMobileDevice();
  
  var touchStart: { x: number; y: number } | null = null
  
  
  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const handleKeyPress = (event: KeyboardEvent) => {
    
    if (event.key === 'a' || event.key === 'ArrowLeft') {
      setLocalHorizontalMovement(1)
    }
    if (event.key === 'd' || event.key === 'ArrowRight') {
      setLocalHorizontalMovement(-1)
    }
    if (event.key === 'w' || event.key === 'ArrowUp' || event.key === ' ') {//last is spacebar
      setLocalVerticalMovement(1)
    }
    if (event.key === 's' || event.key === 'ArrowDown') {
      setLocalVerticalMovement(-1)
    }
  };

  const handleTouchStart = (event: TouchEvent) => {
    const touch = event.touches[0];
    touchStart = { x: touch.clientX, y: touch.clientY };
  };

  const handleTouchEnd = (event: TouchEvent) => {
    if (!touchStart) return;
    
    const touch = event.changedTouches[0];
    const diffX = touchStart.x - touch.clientX;
    const diffY = touchStart.y - touch.clientY;
    touchStart = null;
    
    if(Math.abs(diffX) + Math.abs(diffY) < 10) return;//didn't move enough
      

    if (Math.abs(diffX) > Math.abs(diffY)) {// Movement was more horizontal than vertical
      if (diffX > 0) {
        setLocalHorizontalMovement(1)
      } else {
        setLocalHorizontalMovement(-1)
      }
    } else { // Movement was more vertical than horizontal
      if (diffY > 0) {
        setLocalVerticalMovement(1)
      } else {
        setLocalVerticalMovement(-1)
      }
    }
  };

  const setLocalHorizontalMovement = (value: number) => {
    setHorizontalMovement(value)
    setTimeout(() => { setHorizontalMovement(0) }, 100);
  }
  const setLocalVerticalMovement = (value: number) => {
    setVerticalMovement(value)
    setTimeout(() => { setVerticalMovement(0) }, 100);
  }

  return (
    <div className={`full-sceneui-container ${isVisible === true ? 'active' : 'hidden'}`}>
      <div className="sceneui-container">

        <div className={`sceneui-stats-container ${isLandscape ? '' : 'portrait'}`}>
          <div className="sceneui-stats-container-top">
            <div className="sceneui-stats-container-item">
              <div className="sceneui-stats-item-icon"> <img className='sceneui-stats-item-icon-img' src={iconTime} alt=''/></div>
              <div className="sceneui-stats-item-text">{userTimeUI}</div>
            </div>
            <div className="sceneui-stats-container-item">
              <div className="sceneui-stats-item-icon"><img className='sceneui-stats-item-icon-img' src={iconScore} alt=''/></div>
              <div className="sceneui-stats-item-text">{userScoreUI}</div>
            </div>
          </div>
          <div className="sceneui-stats-container-bottom">
            <div className="sceneui-stats-container-item">
              <div className="sceneui-stats-item-icon"><img className='sceneui-stats-item-icon-img' src={iconLifes} alt=''/></div>
              <div className="sceneui-stats-item-text">{userLifesUI}</div>
            </div>
          </div>
        </div>

        <div className="sceneui-controller-container">
          <div className={`sceneui-controller-left ${isMobile ? 'mobile' : ''}`} onClick={() => setLocalHorizontalMovement(1)}/>
          <div className="sceneui-controller-center">
            <div className={`sceneui-controller-up ${isMobile ? 'mobile' : ''}`} onClick={() => setLocalVerticalMovement(1)}/>
            <div className={`sceneui-controller-down ${isMobile ? 'mobile' : ''}`} onClick={() => setLocalVerticalMovement(-1)}/>
          </div>
          <div className={`sceneui-controller-right ${isMobile ? 'mobile' : ''}`} onClick={() => setLocalHorizontalMovement(-1)}/>
        </div>
 
      </div>
      {gameOver === true && <div className="sceneui-gameover-container"><img className='sceneui-gameover-icon' src={iconGameOver} alt=''/></div>}
    </div>
  );
}
